//Anpassa textstorlek i heroblocket för att inte bryta ord
  export function scale_hero_text() {
    if ((window.outerWidth) < 768 && $('.hero-text').length > 0 && $('.hero-text').width() < $('.hero-text > span').width()) {
      while ($('.hero-text').width() < $('.hero-text > span').width()) {
        var fontsize = parseFloat($('.hero-text > span').css('font-size'));
        fontsize = --fontsize;
        $('.hero-text > span').css('font-size', fontsize + 'px');
      }
    }
  }

  export function scale_text() {
  if ((window.outerWidth) < 768 && $('.scale-text').length > 0) {
    var parents = [];
    $('.scale-text').each(function(){
      var parent = $(this).parent();
      if (!$(parent).hasClass('scale-checked')) {
        $(parent).addClass('scale-checked');
        parents.push($(this).parent());
      }
    });

    $(parents).each(function(){
      var new_font_size = false;
      $('.scale-text', this).each(function(){
        if ($(this)[0].scrollWidth >  $(this).innerWidth()) {
          while ($(this)[0].scrollWidth >  $(this).innerWidth()) {
            var fontsize = parseFloat($(this).css('font-size'));
            fontsize = --fontsize;
            $(this).css('font-size', fontsize + 'px');
            if (!new_font_size || fontsize < new_font_size) {
              new_font_size = fontsize;
            }
          }
        }
      });
      $('.scale-text', this).css('font-size', new_font_size + 'px');
    });
  }
}
